exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".root___2g2n_ {\n  border-radius: 0.25rem;\n  animation: pulse___20gcg 2s infinite;\n}\n\n@keyframes pulse___20gcg {\n  0%, 100% {\n    background-color: none;\n  }\n  50% {\n    background-color: var(--color-dimmest);\n  }\n}\n", ""]);

// exports
exports.locals = {
	"root": "root___2g2n_",
	"pulse": "pulse___20gcg"
};